"use client";
import { useEffect } from "react";
import { clearGlobalContexts } from "@snowplow/browser-tracker";
import { globalTrackerName } from "./config";
export var useSnowplowUserContext = function (props) {
    var isEnabled = props.isEnabled, setUserContextUpdated = props.setUserContextUpdated, setUserContext = props.setUserContext;
    useEffect(function () {
        if (!isEnabled)
            return;
        // reset all global contexts
        clearGlobalContexts([globalTrackerName]);
        setUserContext(setUserContextUpdated);
    }, [isEnabled, setUserContext, setUserContextUpdated]);
};
